<div *ngIf="!isLoading">
    <div
        style=" position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000"></mat-spinner>
</div>

<div class="container">
    <div *ngIf="data_report" [ngStyle]="(isLoading) ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
        <div class="row justify-content-center" style="padding: 5% 0">
            <h1 class="lifedi-color" style="font-weight: bold">
                {{ data_report.reportname }}
            </h1>
        </div>
        <h2 style="text-decoration: underline" style="font-weight: bold; text-decoration: underline">
            {{ data_report.measure_name }}
        </h2>
        <h3 [innerText]="data_report.report_description"></h3>

        <div class="d-flex">
            <h4 class="box-header text-center my-3">
                ผู้ทำแบบทดสอบ
            </h4>
        </div>

        <div class="justify-content-center" style="padding: 5% 0">
            <div *ngIf="data_report">
                <!-- ใส่กราฟ -->
                <div *ngFor="let box of data_report.data">
                    <div style="position: absolute; left: -5000px; width: 50%">
                        <canvas id="ScatterChartpdf{{ box.id }}" #allcanvas></canvas>
                    </div>
                    <div style="margin: 0 auto; width: 50%">
                        <canvas id="ScatterChart{{ box.id }}" #allcanvas></canvas>
                    </div>
                    <div style="padding: 2% 0">
                        <h2 [ngStyle]="{ color: box.xaxis_color }"
                            style="font-weight: bold; text-decoration: underline">
                            {{ box.xaxis_name }}
                        </h2>
                        <h4 [innerText]="box.xaxis_description"></h4>
                        <h2 style="font-weight: bold">
                            คะแนนต่ำสุด : {{ box.xmin }} คะแนนสูงสุด : {{ box.xmax }}
                        </h2>
                        <h2 [ngStyle]="{ color: box.xaxis_color }" style="font-weight: bold">
                            ท่านได้ {{ box.xaxis_value | number: '1.2-2' }} คะแนน
                            <!-- อยู่ในช่วงคะแนน {{ box.xaxis_range }} คะแนน -->
                        </h2>
                        <h4 style="padding-bottom: 3%" [innerText]="box.xaxis_range_description"></h4>
                        <hr style="width: 70%; text-align: center" />
                        <h2 [ngStyle]="{ color: box.yaxis_color }" class="lifedi-color"
                            style="font-weight: bold; text-decoration: underline">
                            {{ box.yaxis_name }}
                        </h2>
                        <h4 [innerText]="box.yaxis_description"></h4>
                        <h2 style="font-weight: bold">
                            คะแนนต่ำสุด : {{ box.ymin }} คะแนนสูงสุด : {{ box.ymax }}
                        </h2>
                        <h2 [ngStyle]="{ color: box.yaxis_color }" class="lifedi-color" style="font-weight: bold">
                            ท่านได้ {{ box.yaxis_value | number: '1.2-2' }} คะแนน
                            <!-- อยู่ในช่วงคะแนน {{ box.yaxis_range }} คะแนน -->
                        </h2>
                        <h4 style="padding-bottom: 3%" [innerText]="box.yaxis_range_description"></h4>
                        <hr style="width: 70%; text-align: center" />
                    </div>

                    <h1 class="lifedi-color" style="text-align: center; font-weight: bold; text-decoration: underline;">
                        สรุปผล
                    </h1>
                    <h2 class="lifedi-color" style="font-weight: bold; text-decoration: underline">
                        {{ box.result_type }}
                    </h2>
                    <h4 style="padding-bottom: 3%" [innerText]="box.result_description"></h4>
                    <hr style="width: 70%; text-align: center; padding-bottom: 3%" />
                </div>
            </div>

            <!-- informant -->
            <hr class="my-2 underline-blue">

            <div class="d-flex">
                <h4 class="box-header text-center my-3">
                    ผู้มีส่วนร่วมในแบบทดสอบนี้
                </h4>
            </div>
        
            <div *ngIf="data_report" class="informant-box my-3">
                <h4 class="text-header">
                    รายงานผลของผู้มีส่วนร่วมนี้เป็นของ
                </h4>
                <div class="d-flex">
                    <h4 *ngFor="let p of data_report.parances; let i = index" class="text-participant">
                        <span *ngIf="i !== 0">,</span>
                        {{ p.EMAIL }} ({{ p.TAG }})
                    </h4>
                </div>
            </div>

            <div *ngIf="data_report">
                <!-- ใส่กราฟ -->
                <div *ngFor="let box of data_report.data2">
                    <div style="position: absolute; left: -5000px; width: 50%">
                        <canvas id="ScatterChartpdfInformant{{ box.id }}" #allcanvas></canvas>
                    </div>
                    <div style="margin: 0 auto; width: 50%">
                        <canvas id="ScatterChartInformant{{ box.id }}" #allcanvas></canvas>
                    </div>
                    <div style="padding: 2% 0">
                        <h2 [ngStyle]="{ color: box.xaxis_color }"
                            style="font-weight: bold; text-decoration: underline">
                            {{ box.xaxis_name }}
                        </h2>
                        <h4 [innerText]="box.xaxis_description"></h4>
                        <h2 style="font-weight: bold">
                            คะแนนต่ำสุด : {{ box.xmin }} คะแนนสูงสุด : {{ box.xmax }}
                        </h2>
                        <h2 [ngStyle]="{ color: box.xaxis_color }" style="font-weight: bold">
                            ท่านได้ {{ box.xaxis_value | number: '1.2-2' }} คะแนน
                            <!-- อยู่ในช่วงคะแนน {{ box.xaxis_range }} คะแนน -->
                        </h2>
                        <h4 style="padding-bottom: 3%" [innerText]="box.xaxis_range_description"></h4>
                        <hr style="width: 70%; text-align: center" />
                        <h2 [ngStyle]="{ color: box.yaxis_color }" class="lifedi-color"
                            style="font-weight: bold; text-decoration: underline">
                            {{ box.yaxis_name }}
                        </h2>
                        <h4 [innerText]="box.yaxis_description"></h4>
                        <h2 style="font-weight: bold">
                            คะแนนต่ำสุด : {{ box.ymin }} คะแนนสูงสุด : {{ box.ymax }}
                        </h2>
                        <h2 [ngStyle]="{ color: box.yaxis_color }" class="lifedi-color" style="font-weight: bold">
                            ท่านได้ {{ box.yaxis_value | number: '1.2-2' }} คะแนน
                            <!-- อยู่ในช่วงคะแนน {{ box.yaxis_range }} คะแนน -->
                        </h2>
                        <h4 style="padding-bottom: 3%" [innerText]="box.yaxis_range_description"></h4>
                        <hr style="width: 70%; text-align: center" />
                    </div>

                    <h1 class="lifedi-color" style="text-align: center; font-weight: bold; text-decoration: underline;">
                        สรุปผล
                    </h1>
                    <h2 class="lifedi-color" style="font-weight: bold; text-decoration: underline">
                        {{ box.result_type }}
                    </h2>
                    <h4 style="padding-bottom: 3%" [innerText]="box.result_description"></h4>
                    <hr style="width: 70%; text-align: center; padding-bottom: 3%" />
                </div>
            </div>
        </div>
        <div class="justify-content-center" style="padding: 5% 0">
            <div style="text-align: center; padding: 5% 0" *ngIf="data_report">
                <lifedi-btn lable="ดาวน์โหลด" (click)="filepdf('download')" customStyle="background: #005C3D; color: #FFFFFF; margin-top: 0px;
            padding: 0 25px;">
                </lifedi-btn>
            </div>
        </div>
    </div>
</div>